

const MembershipEnquiryHero = () => {
  return (
    <section
      className="w-full relative"
      style={{
        height: '484px',
        paddingLeft: '64px',
        paddingRight: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src="/Member Services/Your Life Our Masterpiece/bg.png"
        alt="Membership Enquiry"
        className="w-full h-full object-cover"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: -1
        }}
      />
      <div className="w-full text-center">
        <h1
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '32px',
            color: '#FFFFFF',
            fontWeight: '400',
            marginBottom: '32px',
            textAlign: 'center'
          }}
        >
          Apply for Membership
        </h1>
        
        <p
          style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            fontSize: '16px',
            color: '#FFFFFF',
            lineHeight: '1.6',
            textAlign: 'center',
            maxWidth: '800px',
            margin: '0 auto'
          }}
        >
          Kindly complete the form below to initiate your application. A dedicated member of our team will be in touch shortly to discuss your membership in greater detail.
          <br /><br />
          For general enquiries, please contact us at +852 2207 3191.
        </p>
      </div>
    </section>
  )
}

export default MembershipEnquiryHero